import { useState } from "react";
import { StorageUtil } from "utils";
import { getInteractor } from "services/local.service";
import { AppConstant } from "const";

const useAccountList = () => {
  const prefixKey = StorageUtil.getCurrentPrefixKey();

  const [accountList, setAccountList] = useState([]); // List accounts of current branch include current account
  const [queryPagination, setQueryPagination] = useState({ page: 0, totalPage: 1, totalItems: 0 });

  // HOTFIX: add key identifyId = contact.contact_id = account.id to mapping with contactList. When create group/channel, using identifyId
  const getAccountList = async (condition = { keyword: "" }) => {
    const { keyword, page, ...otherCondition } = condition;
    const searchKeyword = keyword ? keyword.trim() : "";
    const requestPage = page || 1;
    const {
      data: accountsInBranch,
      totalPage,
      totalItems,
    } = await getInteractor(prefixKey).LocalAccountService.searchAccountList({
      keyword: searchKeyword,
      offset: AppConstant.PAGE_SIZE * (requestPage - 1),
      limit: AppConstant.PAGE_SIZE,
      ...otherCondition,
    });

    const newAccountList = requestPage === 1 ? accountsInBranch : accountList.concat(accountsInBranch);
    const refactorAccountList = newAccountList.map(item => ({ ...item, identifyId: item.id }));
    setTimeout(() => {
      setAccountList(refactorAccountList);
      setQueryPagination({
        page: requestPage,
        totalPage: totalPage,
        totalItems: totalItems || 0,
      });
    }, 0);

    return refactorAccountList;
  };

  return { accountList, queryPagination, getAccountList };
};

export default useAccountList;
